import { render, staticRenderFns } from "./project-all.vue?vue&type=template&id=2d9bf7ca"
import script from "./project-all.vue?vue&type=script&lang=tsx"
export * from "./project-all.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports